<template>
  <div>
    <div
      class="porteur"
      :style="{ background: background, border: border, color: color }"
    >
      <div class="pl-4 pr-4">
        {{ title }}
      </div>
      <base-button class="btn mt-3" :type="bouton" @click="galerie">
        Voir plus
      </base-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},

  props: {
    background: {
      type: String,
      default: "#166276eb",
    },
    bouton: {
      type: String,
      default: "warning",
    },
    color: {
      type: String,
      default: "white",
    },
    title: {
      type: String,
      default: "warning",
    },
    border: {
      type: String,
      default: "2px solid white",
    },
  },

  methods: {
    galerie() {
      this.$router.push("/galerie");
    },
  },
};
</script>
<style>
.porteur {
  padding: 15px;
  width: 100%;
  border-radius: 5px;
}
</style>
